var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled from "styled-components";
export var ChannelLogo = function (_a) {
    var channel = _a.channel, className = _a.className, isColor = _a.isColor, isOrange = _a.isOrange, isMonogram = _a.isMonogram, accentColor = _a.accentColor, isBanner = _a.isBanner, props = __rest(_a, ["channel", "className", "isColor", "isOrange", "isMonogram", "accentColor", "isBanner"]);
    switch (channel) {
        case "VTM":
            return (React.createElement(Logo, { "data-component": props["data-component"], className: className, src: isMonogram ? "/images/logos/vtm-monogram.svg" :
                    isOrange
                        ? "/images/logos/vtm-orange.svg"
                        : isColor
                            ? "/images/logos/vtm-multicolor.png"
                            : "/images/logos/vtm-2024.svg", alt: "VTM Logo" }));
        case "VTM2":
            return (React.createElement(Logo, { "data-component": props["data-component"], className: className, src: isColor ? "/images/logos/vtm-2-color-2024.svg"
                    : accentColor ? "/images/logos/vtm-2-color-accent.svg"
                        : "/images/logos/vtm-2.svg", alt: "VTM 2 Logo" }));
        case "VTM3":
            return (React.createElement(Logo, { "data-component": props["data-component"], className: className, src: isColor ? "/images/logos/vtm-3-color-2024.svg"
                    : accentColor ? "/images/logos/vtm-3-color-accent.svg"
                        : "/images/logos/vtm-3.svg", alt: "VTM 3 Logo" }));
        case "VTM4":
            return (React.createElement(Logo, { "data-component": props["data-component"], className: className, src: isColor ? "/images/logos/vtm-4-color-2024.svg"
                    : accentColor ? "/images/logos/vtm-4-color-accent.svg"
                        : "/images/logos/vtm-4.svg", alt: "VTM 4 Logo" }));
        case "VTMGOEXCLUSIVES":
            return (React.createElement(Logo, { "data-component": props["data-component"], className: className, src: isColor
                    ? "/images/logos/vtm-go-pink.svg"
                    : isBanner ? "/images/logos/vtm-go-pink.svg" : "/images/logos/vtm-go-pink.svg", alt: "VTM GO Logo" }));
        case "VTMGOPLUS":
            return (React.createElement(Logo, { "data-component": props["data-component"], className: className, src: isColor || isBanner
                    ? "/images/logos/vtm-go-plus-color-2024.svg"
                    : "/images/logos/vtm-go-plus.svg", alt: "VTM GO Plus Logo" }));
        case "NEWS":
            return (React.createElement(Logo, { "data-component": props["data-component"], className: className, src: "/images/logos/vtm-nieuws-2024.svg", alt: "VTM GO Plus Logo" }));
        default:
            return null;
    }
};
export var Logo = styled.img(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  width: auto;\n  height: 1.125rem;\n"], ["\n  position: relative;\n  width: auto;\n  height: 1.125rem;\n"])));
var templateObject_1;
